/* « Données de démonstration » — the one line that says these figures are not the merchant's yet.
   Product-audit ruling 08/10/2026 (orchestrator/product-audits-ruling-2026-10-08.md, item 2.27):
   Résultats and the campaign page still compute their numbers from fixtures until Technical's
   results endpoints land (T4.1) and the screens read them (T4.2). Delete this file with T4.2. */
import { Note } from '@/ui'

export const DEMO_BANNER_TEXT = 'Données de démonstration.'

export function DemoBanner() {
  return (
    <div data-testid="demo-banner">
      <Note tone="candour"><b>{DEMO_BANNER_TEXT}</b> Ces chiffres ne sont pas encore les vôtres&nbsp;: ils arrivent avec vos premières participations.</Note>
    </div>
  )
}
